/**
 * APEX AUTOWERKS — Theme JavaScript
 * Cart drawer, mobile nav, product gallery, quantity selectors, variant switching, tabs
 */
(function () {
  'use strict';

  // ========== CART DRAWER ==========
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartBody = document.querySelector('[data-cart-body]');
  const cartFooter = document.querySelector('[data-cart-footer]');
  const cartSubtotal = document.querySelector('[data-cart-subtotal]');
  const cartCount = document.querySelector('[data-cart-count]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
      refreshCart();
    });
  });

  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });

  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function formatMoney(cents) {
    var fmt = window.ApexAutowerks && window.ApexAutowerks.moneyFormat || '£{{amount}}';
    return fmt.replace('{{amount}}', (cents / 100).toFixed(2))
              .replace('{{amount_no_decimals}}', Math.round(cents / 100))
              .replace('{{amount_with_comma_separator}}', (cents / 100).toFixed(2).replace('.', ','));
  }

  function refreshCart() {
    fetch((window.ApexAutowerks && window.ApexAutowerks.cartCountUrl) || '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cartCount) cartCount.textContent = cart.item_count;

        if (cart.item_count === 0) {
          if (cartBody) cartBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty</p>';
          if (cartFooter) cartFooter.style.display = 'none';
          return;
        }

        if (cartFooter) cartFooter.style.display = '';
        if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);

        var html = '';
        cart.items.forEach(function (item) {
          html += '<div style="display:flex;gap:12px;padding:12px 0;border-bottom:1px solid var(--color-border);">';
          if (item.featured_image && item.featured_image.url) {
            html += '<div style="width:64px;height:64px;border-radius:4px;overflow:hidden;background:var(--color-bg-card);flex-shrink:0;">';
            html += '<img src="' + item.featured_image.url.replace(/(\.\w+)\?/, '_200x$1?') + '" alt="" style="width:100%;height:100%;object-fit:cover;">';
            html += '</div>';
          }
          html += '<div style="flex:1;min-width:0;">';
          html += '<p style="font-size:0.875rem;font-weight:500;color:var(--color-white);margin:0 0 4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + item.product_title + '</p>';
          if (item.variant_title && item.variant_title !== 'Default Title') {
            html += '<p style="font-size:0.75rem;color:var(--color-text-secondary);margin:0 0 4px;">' + item.variant_title + '</p>';
          }
          html += '<p style="font-size:0.8125rem;color:var(--color-text-secondary);margin:0;">Qty: ' + item.quantity + '</p>';
          html += '</div>';
          html += '<div style="text-align:right;flex-shrink:0;">';
          html += '<p style="font-size:0.875rem;font-weight:600;margin:0;">' + formatMoney(item.final_line_price) + '</p>';
          html += '</div>';
          html += '</div>';
        });

        if (cartBody) cartBody.innerHTML = html;
      })
      .catch(function (e) { console.error('Cart fetch error:', e); });
  }

  // ========== ADD TO CART (AJAX) ==========
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-add-to-cart');
    if (!variantId) return;

    fetch((window.ApexAutowerks && window.ApexAutowerks.cartAddUrl) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        openCart();
        refreshCart();
      })
      .catch(function (e) { console.error('Add to cart error:', e); });
  });

  // ========== MOBILE NAV ==========
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileOverlay = document.querySelector('[data-mobile-overlay]');

  function openMobile() {
    if (mobileNav) mobileNav.classList.add('is-open');
    if (mobileOverlay) mobileOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobile() {
    if (mobileNav) mobileNav.classList.remove('is-open');
    if (mobileOverlay) mobileOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-mobile-toggle]').forEach(function (btn) {
    btn.addEventListener('click', openMobile);
  });
  document.querySelectorAll('[data-mobile-close]').forEach(function (btn) {
    btn.addEventListener('click', closeMobile);
  });
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobile);

  // ========== PRODUCT GALLERY ==========
  document.querySelectorAll('[data-thumb-btn]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = this.getAttribute('data-full-src');
      var mainImg = document.querySelector('[data-main-img]');
      if (mainImg && src) mainImg.src = src;
      document.querySelectorAll('[data-thumb-btn]').forEach(function (t) {
        t.classList.remove('product-gallery__thumb--active');
      });
      this.classList.add('product-gallery__thumb--active');
    });
  });

  // ========== QUANTITY SELECTORS ==========
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-qty-minus]')) {
      var input = e.target.closest('.qty-selector').querySelector('.qty-input, [data-qty-input]');
      if (input && parseInt(input.value, 10) > 1) {
        input.value = parseInt(input.value, 10) - 1;
        input.dispatchEvent(new Event('change'));
      }
    }
    if (e.target.closest('[data-qty-plus]')) {
      var input = e.target.closest('.qty-selector').querySelector('.qty-input, [data-qty-input]');
      if (input) {
        input.value = parseInt(input.value, 10) + 1;
        input.dispatchEvent(new Event('change'));
      }
    }
  });

  // ========== VARIANT SELECTOR ==========
  document.querySelectorAll('.variant-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = this.closest('.variant-group');
      group.querySelectorAll('.variant-option').forEach(function (o) {
        o.classList.remove('variant-option--active');
      });
      this.classList.add('variant-option--active');

      // Build selected options array and match to variant
      var selectedOptions = [];
      document.querySelectorAll('.variant-group').forEach(function (g) {
        var active = g.querySelector('.variant-option--active');
        if (active) selectedOptions.push(active.getAttribute('data-value'));
      });

      var select = document.querySelector('[data-variant-select]');
      if (!select) return;
      var options = select.querySelectorAll('option');
      for (var i = 0; i < options.length; i++) {
        var optTitle = options[i].textContent.trim();
        if (optTitle === selectedOptions.join(' / ')) {
          select.value = options[i].value;
          // Update price display
          var priceEl = document.querySelector('.price-current');
          if (priceEl && options[i].dataset.price) {
            priceEl.textContent = options[i].dataset.price;
          }
          // Update add-to-cart state
          var addBtn = document.querySelector('[data-add-btn]');
          if (addBtn) {
            if (options[i].disabled) {
              addBtn.textContent = 'Sold out';
              addBtn.disabled = true;
            } else {
              addBtn.textContent = 'Add to cart';
              addBtn.disabled = false;
            }
          }
          break;
        }
      }
    });
  });

  // ========== PRODUCT TABS ==========
  document.querySelectorAll('[data-tab]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tabId = this.getAttribute('data-tab');
      document.querySelectorAll('.product-tabs__btn').forEach(function (b) {
        b.classList.remove('product-tabs__btn--active');
      });
      document.querySelectorAll('.product-tabs__panel').forEach(function (p) {
        p.classList.remove('product-tabs__panel--active');
      });
      this.classList.add('product-tabs__btn--active');
      var panel = document.querySelector('[data-panel="' + tabId + '"]');
      if (panel) panel.classList.add('product-tabs__panel--active');
    });
  });

  // ========== CART PAGE QTY BUTTONS ==========
  document.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('[data-line-minus]');
    var plusBtn = e.target.closest('[data-line-plus]');
    if (minusBtn) {
      var idx = minusBtn.getAttribute('data-line-minus');
      var input = document.querySelector('[data-line-qty="' + idx + '"]');
      if (input && parseInt(input.value, 10) > 0) {
        input.value = parseInt(input.value, 10) - 1;
      }
    }
    if (plusBtn) {
      var idx = plusBtn.getAttribute('data-line-plus');
      var input = document.querySelector('[data-line-qty="' + idx + '"]');
      if (input) input.value = parseInt(input.value, 10) + 1;
    }
  });

  // ========== REMOVE CART ITEM ==========
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-remove-key]');
    if (!removeBtn) return;
    e.preventDefault();
    var key = removeBtn.getAttribute('data-remove-key');
    fetch((window.ApexAutowerks && window.ApexAutowerks.cartUpdateUrl) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function () { window.location.reload(); })
      .catch(function (e) { console.error('Remove error:', e); });
  });

  // ========== SEARCH OVERLAY ==========
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchInput = document.querySelector('[data-search-input]');
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (searchOverlay) searchOverlay.classList.add('is-open');
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 100);
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchOverlay) searchOverlay.classList.remove('is-open');
    });
  });
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) searchOverlay.classList.remove('is-open');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-open')) {
      searchOverlay.classList.remove('is-open');
    }
  });

  // ========== TOUCH-FRIENDLY DROPDOWN TOGGLE ==========
  document.querySelectorAll('.header__nav-item').forEach(function (item) {
    if (item.querySelector('.header__nav-dropdown')) {
      var link = item.querySelector('.header__nav-link');
      if (link) {
        link.addEventListener('click', function (e) {
          // Only intercept on touch / small screens
          if (window.matchMedia('(hover: none)').matches) {
            e.preventDefault();
            item.classList.toggle('is-open');
          }
        });
      }
    }
  });

})();
